import React, { useState, useEffect } from 'react';

const phrases = [
    "Don't Let Your Agency Burn Your Budget.",
    "Control Where Your Cash is Actually Going.",
    "Clarity for Founders Lost in Dev Talk.",
    "Stop Guessing. Start Leading Your Tech Team.",
    "If You're the Last to Know, That's No Bueno."
];

const TypingAnimation = () => {
  const [currentPhraseIndex, setCurrentPhraseIndex] = useState(0);
  const [displayedText, setDisplayedText] = useState('');
  const [isTyping, setIsTyping] = useState(true);

  useEffect(() => {
    const currentPhrase = phrases[currentPhraseIndex];

    if (isTyping) {
      if (displayedText.length < currentPhrase.length) {
        const timeout = setTimeout(() => {
          setDisplayedText(currentPhrase.slice(0, displayedText.length + 1));
        }, 35); // Typing speed
        return () => clearTimeout(timeout);
      } else {
        // Finished typing, wait 3 seconds then start erasing
        const timeout = setTimeout(() => {
          setIsTyping(false);
        }, 3000);
        return () => clearTimeout(timeout);
      }
    } else {
      // Delete the whole phrase at once and move to next phrase
      setDisplayedText('');
      setCurrentPhraseIndex((prev) => (prev + 1) % phrases.length);
      setIsTyping(true);
    }
  }, [displayedText, isTyping, currentPhraseIndex]);

  return (
    <span>
      {displayedText}
      <span className="animate-pulse">|</span>
    </span>
  );
};

export default TypingAnimation;